import { ILotteryResult } from '@bg-shared/business/Reports/interfaces';

export const getBetMatchedNumbers = (
    items?: ILotteryResult[],
    currentResults?: number[],
): number[] => {
    if (!items && !currentResults) {
        return [];
    }

    return items
        .map((item) => item.number)
        .filter((number) => (currentResults || []).includes(number));
};
